const SubTitle = ({ children }) => (
  <h5 className="text-[18px] sm:text-[24px] mb-4 sm:mb-6 text-gray-900 font-bold">
    {children}
  </h5>
);

export default SubTitle;
